import { Component, Input, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ConstantesConfiguracionCalendarioEnum } from '@appNeo/core/helpers/enums/constantesConfiguracionCalendarioEnum';
import { PreferenciasService } from '@appNeo/neoCore/services/preferencias/preferencias.service';
import { AuxiliarService } from '@appNeo/neoShared/services/auxiliar/auxiliar.service';
import { ProximamenteDlgComponent } from '@appNeo/pages/components/proximamente-dlg/proximamente-dlg.component';
import { environment } from '@environments/environment';
import { finalize } from 'rxjs';
import { MainAccionesDialogoCtaComponent } from '../main-acciones-dialogo-cta/main-acciones-dialogo-cta.component';


@Component({
  selector: 'neo-main-header-cta',
  templateUrl: './main-header-cta.component.html',
  styleUrls: ['./main-header-cta.component.scss']
})
export class MainHeaderCtaComponent implements OnInit {

  @Input() url: string;
  @Input() path: string;
  @Input() target = false;
  @Input() iconoClase = 'icon-24 icon-ibm-arrow_right';
  @Input() icono: string;
  @Input() label = 'Te llamamos';

  @Input() comprobarAccion = true;
  @Input() constanteComprobarAccion = ConstantesConfiguracionCalendarioEnum.AccesoAltaReservasPublico;
  desencadenarAccion: boolean = !environment.proximamente_reservas;

  @ViewChildren(MainAccionesDialogoCtaComponent) accionesDialogoCta: QueryList<MainAccionesDialogoCtaComponent>;
  @ViewChildren(ProximamenteDlgComponent) accionesDialogoProximamente: QueryList<ProximamenteDlgComponent>;
  constructor(
    private dialog: MatDialog,
    private router: Router,
    private preferenciasService: PreferenciasService,
    private auxiliarService: AuxiliarService
  ) { }

  ngOnInit(): void {
  }

  clickLink() {
    console.log('accion clickLInk ', this.desencadenarAccion);
    if (this.comprobarAccion) {
      this.validarAccion();
    } else {
      console.log('accion clickLInk sin validacion');
      this.accion();
    }
  }

  accion() {
    console.log('accion desncad ', this.desencadenarAccion);
    if (this.desencadenarAccion) {
      console.log('desencadenar accion');
      (this.url || this.path)
        ? this.redireccion()
        : this.dialog.open(this.accionesDialogoCta.first.dialogCta, { disableClose: true, width: '540px', minWidth: '300px', panelClass: ['dialogoMainCta'] });
    } else {
      console.log('proxima');
      this.mostrarProximamente();
    }


  }

  redireccion() {
    if (this?.path && this.path.length > 0) {
      this.router.navigate([this.path]);
    } else {
      window.location.href = this.url
    }
  }

  validarAccion() {
    this.preferenciasService.getApi(this.constanteComprobarAccion, true)
      .pipe(
        finalize(() => {
          this.accion();
        })
      )
      .subscribe(
        x => this.desencadenarAccion = this.auxiliarService.getBoolean(x.valor),
        e => this.desencadenarAccion = this.auxiliarService.getBoolean(this.preferenciasService.get(this.constanteComprobarAccion))
      );
  }


  mostrarProximamente() {
    this.dialog.open(this.accionesDialogoProximamente.first.dialogProximamente, { disableClose: false, width: '540px', minWidth: '300px', panelClass: ['dialogoProximamente'] });
  }
}
